class ListModel {
	data;

	constructor(data) {
		this.data = data;
	}

	deleteItem(index) {
		this.data.splice(index, 1);
	}

	addItem(template) {
		let item = {};
		for (let key of Object.keys(template)) {
			if (typeof(template[key]) === "object") {
				item[key] = [];
			} else if (typeof(template[key]) === "function") {
				item[key] = template[key]();
			} else {
				item[key] = template[key];
			}
		}
		this.data.unshift(item);
	}
}

export default(ListModel);
